<template>
  <table cellspacing="0" cellpadding="0" border="0"  :class="{'width-smll':widthSmll}">
    <thead class="bee-table-head" :class="{'bee-table-header':styleHead}">
    <tr>
      <th v-for="(col, index) in columns" :key="index" ref="colHeadWidth"  :class="{'thd-select':col.type === 'selection' || col.type === 'radio','no-border':!showBorder}">
        <template v-if="col.type === 'selection'">
          <input
            type="checkbox"
            class="input-class checkbox"
            v-model="select"
            :name="data"
            :disabled="!data.length"
            @change="changeAll"
          />
        </template>
        <template v-else-if="col.type === 'radio'">
          <span></span>
        </template>
        <template v-else>
          <div class="cell">
            <span>{{col.title}}</span>
            <span class="caret-wrapper" v-if="col.sortable" ref="sortParent">
              <i class="sort-caret ascending" @click.stop="asc($event,col.key,col.sortable)"></i>
              <i class="sort-caret descending" @click.stop="des($event,col.key,col.sortable)"></i>
            </span>
          </div>
        </template>
      </th>
    </tr>
    </thead>
  </table>
</template>
<script>
export default {
  name: 'TableHead',
  props: {
    columns: Array, // 表头
    data: Array, // 表格数据
    showHead: { // 是否显示表头
      type: Boolean,
      default: true
    },
    showBorder: Boolean, // 是否显示边框
    styleHead: { // 是否显示默认表头样式
      type: Boolean,
      default: true
    },
    width: { // 自定义列宽
      type: [String, Number]
    },
    widthSmll: { // 固定表头的宽度是否-17
      type: Boolean,
      default: false
    },
    align: { // 表格文字对齐方式
      type: String,
      default: 'left'
    },
    selectAll: Object // 全选情况
  },
  data() {
    return {
      select: false // 是否全选中
    }
  },
  components: {
  },
  computed: {
  },
  watch: {
    // 当数据发生变化时，重置多选选中情况
    data(n, o) {
      this.select = false
      this.$emit('changeAll', this.select)
    },
    // 监视全选情况
    'selectAll': {
      handler() {
        this.select = this.selectAll.value
      },
      deep: true
    }
  },
  methods: {
    // 全选中
    changeAll(e) {
      this.$emit('changeAll', this.select)
    },
    // 排序升序 prop:属性 sortable:是否排序(false/true/'custom')
    asc(e, prop, sortable) {
      this.$refs.sortParent.forEach(item => {
        item.classList.remove('ascending')
        item.classList.remove('descending')
      })
      e.target.parentElement.classList.add('ascending')
      e.target.parentElement.classList.remove('descending')
      this.$emit('sortChange', prop, sortable, 'ascending')
    },
    // 排序降序
    des(e, prop, sortable) {
      this.$refs.sortParent.forEach(item => {
        item.classList.remove('ascending')
        item.classList.remove('descending')
      })
      e.target.parentElement.classList.add('descending')
      e.target.parentElement.classList.remove('ascending')
      this.$emit('sortChange', prop, sortable, 'descending')
    }
  },
  created() {
    // 表头全选情况
    this.columns.forEach((item) => {
      if(item.type && item.type === 'selection') {
        item._value = false
      }
    })
    this.$nextTick(() => {
      // 自定义表格宽度
      let tds = this.$refs.colHeadWidth
      for(let i = 0; i < tds.length; i++) {
        tds[i].style.width = this.width.toString().replace('px', '') + 'px'
        tds[i].style.textAlign = this.align
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/table/tableHead.vue